import React, { useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Componente CustomDDVariavel
 * Props:
 * - variaveis: array de objetos { nome }
 * - value: valor selecionado
 * - onChange: função chamada ao mudar (recebe string)
 * - placeholder: texto placeholder
 */
export const CustomDDVariavel = ({ variaveis = [], value = '', onChange, placeholder = 'Selecione variável' }) => {
    const [dragOverType, setDragOverType] = useState(null); // null | 'variavel' | 'node'
    const isVar = value && variaveis.some(v => v.nome === value);

    const handleDragOver = (e) => {
        e.preventDefault();
        const isVarType = !!e.dataTransfer.types.find(t => t === 'application/variavel');
        setDragOverType(isVarType ? 'variavel' : 'node');
    };
    const handleDragLeave = () => setDragOverType(null);
    const handleDrop = (e) => {
        e.preventDefault();
        const data = e.dataTransfer.getData('application/variavel');
        if (!data) {
            setDragOverType(null);
            return;
        }
        const v = JSON.parse(data);
        onChange(v.nome);
        setDragOverType(null);
    };

    const handleSelectChange = (e) => onChange(e.target.value);
    const handleRemoveVar = () => onChange('');

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            {isVar ? (
                <div
                    style={{
                        display: 'flex', alignItems: 'center',
                        border: dragOverType === 'variavel' ? '2px solid #28a745' : '1px solid #28a745',
                        background: '#eaffea',
                        borderRadius: '6px',
                        padding: '6px 12px',
                        minHeight: 38,
                        position: 'relative',
                        marginTop: 4,
                        marginBottom: 4
                    }}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    <span style={{ fontWeight: 600, color: '#28a745', marginRight: 8 }}>{value}</span>
                    <button
                        onClick={handleRemoveVar}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc3545', fontSize: 18, marginLeft: 4 }}
                        title="Remover variável"
                    >
                        <CancelIcon fontSize="inherit" />
                    </button>
                </div>
            ) : (
                <select
                    value={value}
                    onChange={handleSelectChange}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{ width: '100%', padding: '6px 12px', marginTop: 4, marginBottom: 4 }}
                >
                    <option value="" disabled>{placeholder}</option>
                    {variaveis.map((v, idx) => (
                        <option key={idx} value={v.nome}>{v.nome}</option>
                    ))}
                </select>
            )}
            {!isVar && dragOverType === 'variavel' && (
                <CheckCircleIcon style={{ position: 'absolute', top: 7, right: 2, color: 'green', fontSize: 22, zIndex: 2 }} />
            )}
            {!isVar && dragOverType === 'node' && (
                <CancelIcon style={{ position: 'absolute', top: 7, right: 2, color: 'red', fontSize: 22, zIndex: 2 }} />
            )}
        </div>
    );
};
